import { API_URL } from 'shared/api/Constants';
import { apiInterceptor } from './axios';

export const setChatConversationStatusAPI = (params: any) => {
  return apiInterceptor.post(`${API_URL.GET_CHARTID_CONVERSATION_STATUS}`, params).then((response: any) => {
    return response;
  });
};

export const getChatConversationStatusAPI = (params: any) => {
  return apiInterceptor.get(`${API_URL.GET_CONVERSATION_STATUS}/${params}`).then((response: any) => {
    return response;
  });
};

export const getOfficeListByStatusAPI = (status: string) => {
  return apiInterceptor.get(`${API_URL.ADD_OR_UPDATE_OFFICE}?status=${status}`).then((response: any) => {
    return response;
  });
};

export const updateOfficeAPI = (id: number, params: any) => {
  return apiInterceptor.post(`${API_URL.ADD_OR_UPDATE_OFFICE}`, params).then((response: any) => {
    return response;
  });
};

export const getOfficeSearchListByStatusAndTypeAPI = (status: string, type: string) => {
  return apiInterceptor.get(`${API_URL.SEARCH_OFFICE}?status=${status}&type=${type}`).then((response: any) => {
    return response;
  });
};

export const getChartIdAPI = (id: any) => {
  return apiInterceptor.get(`${API_URL.GET_CHARTID}/${id}`).then((response: any) => {
    return response;
  });
};

export const getChartSarchListAPI = (searchText: string) => {
  return apiInterceptor.get(`${API_URL.SEARCH_CHART}?searchText=${searchText}`).then((response: any) => {
    return response;
  });
};

export const getPatientSearchListAPI = (searchText: string) => {
  return apiInterceptor.get(`${API_URL.SEARCH_PATIENTS}?searchText=${searchText}`).then((response: any) => {
    return response;
  });
};

export const getVMANamesAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_VMA_NAMES}`).then((response: any) => {
    return response;
  });
};

export const createTaskAPI = (params: any) => {
  return apiInterceptor.post(`${API_URL.CREATE_TASK}`, params).then((response: any) => {
    return response;
  });
};

/**
 * Creates a task from a yml template via the existing /task/auto-create (TaskTriggerRequest).
 * MM-1130: used by "Request Your Balance" with eventType PENDING-BALANCE and the questions in remarks.
 *
 * @param data patientId, userId, patientName, eventType and optional remarks
 */
export const autoCreateTaskAPI = (data: {
  patientId: number;
  userId: number;
  patientName: string;
  eventType: string;
  remarks?: string;
}) => {
  return apiInterceptor.post(`${API_URL.AUTO_CREATE_TASK}`, data).then((response: any) => {
    return response;
  });
};

export const getTaskListAPI = (data: any) => {
  // category tabs list the open tasks of one category, the Closed tab lists by status
  const listPath = data.category ? `category/${data.category}` : data.listType;
  return apiInterceptor.get(`${API_URL.GET_TASK_LIST}/${data.id}/${listPath}`).then((response: any) => {
    return response;
  });
};

export const getTaskCountAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_TASK_COUNT}`).then((response: any) => {
    return response;
  });
};

export const getPatientTaskListAPI = (id: any) => {
  return apiInterceptor.get(`${API_URL.GET_PATIENT_TASK_LIST}/${id}`).then((response: any) => {
    return response;
  });
};

export const getUnassignedConversationsAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_UNASSIGNED_CONVERSATION}`).then((response: any) => {
    return response;
  });
};

export const getAssignedConversationsAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_ASSIGNED_CONVERSATION}`).then((response: any) => {
    return response;
  });
};
export const getConversationGroupDetailsAPI = (id: number) => {
  return apiInterceptor.get(`${API_URL.GET_GROUP_DETAILS}/${id}`).then((response: any) => {
    return response;
  });
};

export const assignConversationToSelfAPI = (id: any) => {
  return apiInterceptor.post(`${API_URL.ASSIGN_CONVERSATION_TO_SELF}/${id}`).then((response: any) => {
    return response;
  });
};

export const assignConversationToOthersAPI = (groupId: any, id: number) => {
  return apiInterceptor.post(`${API_URL.ASSIGN_CONVERSATION_TO_OTHER}/${groupId}/vma/${id}`).then((response: any) => {
    return response;
  });
};

export const joinConversationAPI = (groupId: any) => {
  return apiInterceptor.post(`${API_URL.JOIN_CONVERSATION}/${groupId}`).then((response: any) => {
    return response;
  });
};
export const getConversationCountAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_CONVERSATION_COUNT}`).then((response: any) => {
    return response;
  });
};

export const getVMAStatusAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_VMA_STATUS_COUNT}`).then((response: any) => {
    return response;
  });
};

export const getPatientNamesAPI = (groupId: string) => {
  return apiInterceptor.get(`${API_URL.GET_PATIENT_NAMES}/${groupId}`).then((response: any) => {
    return response;
  });
};

export const getGroupMembersAPI = (groupId: number) => {
  return apiInterceptor.get(`${API_URL.GET_GROUP_MEMBERS}/${groupId}`).then((response: any) => {
    return response;
  });
};